import * as React from 'react'

import { CircleIcon, HexagonIcon, SquareIcon } from 'lucide-react'
import { observer } from 'mobx-react'

import { SitemapItemShapeType } from '~/client/graph'
import MapViewItemBase from '~/client/src/shared/components/SitemapHelpers/models/MapViewItemBase'
import { isBeyondOneRingShape } from '~/client/src/shared/components/SitemapHelpers/models/PolyLineShapeCoordinates'
import MapViewItemDrawnPart from '~/client/src/shared/components/SitemapHelpers/models/SitemapItemDrawnPart'

import MapViewItemsSetupStore from '../../stores/MapViewItemsSetup.store'
import PropertySelect from './PropertySelect'

interface IProps {
  item: MapViewItemBase
  store: MapViewItemsSetupStore

  setInitValues?: () => void
}

const { Circle, Rectangle, Polyline } = SitemapItemShapeType
const OPTION_BY_SHAPE = {
  [Circle]: <CircleIcon size={16} className="tw:block" />,
  [Rectangle]: <SquareIcon size={16} className="tw:block" />,
  [Polyline]: <HexagonIcon size={16} className="tw:block" />,
}

const NONE_VALUE = null
const none = 'None'

@observer
export default class ShapeSelector extends React.Component<IProps> {
  public render() {
    const {
      store: { getAllowedShapesForType, isGlobeMode },
      item: {
        sitemapItemProperties: { shapeProperties },
        dataObject,
        sitemapItem,
      },
    } = this.props

    const selectedValue = isGlobeMode
      ? sitemapItem?.shapeCoordinates?.type
      : shapeProperties?.type
    const allowedShapes = getAllowedShapesForType(dataObject.type)
    // Another shape type would replace every part and hole with one fresh outline; None only
    // removes the shape.
    const isBeyondOneRing =
      isGlobeMode && isBeyondOneRingShape(sitemapItem?.shapeCoordinates)

    const options = [
      { value: NONE_VALUE, label: none },
      ...allowedShapes.map(value => ({
        value,
        label: OPTION_BY_SHAPE[value],
        disabled: isBeyondOneRing,
      })),
    ]
    return (
      <PropertySelect
        options={options}
        value={selectedValue || NONE_VALUE}
        className="inline-selector"
        onChange={this.onShapeChange}
      />
    )
  }

  private onShapeChange = (shapeType: SitemapItemShapeType) => {
    const { item, store, setInitValues } = this.props
    store.deselectMapViewItemDrawnPart()
    item.updateShape(shapeType, store.isGlobeMode, store.mapBearing)
    if (shapeType === SitemapItemShapeType.Circle && !store.isGlobeMode) {
      setInitValues?.()
    }
    store.selectSitemapItemDrawnPart(MapViewItemDrawnPart.Shape)
    store.addCurrentStateToHistory()
  }
}
